import { render, staticRenderFns } from "./CategoryIndex.vue?vue&type=template&id=1b48a382&scoped=true"
import script from "./CategoryIndex.vue?vue&type=script&lang=js"
export * from "./CategoryIndex.vue?vue&type=script&lang=js"
import style0 from "./CategoryIndex.vue?vue&type=style&index=0&id=1b48a382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b48a382",
  null
  
)

export default component.exports